import { Controller } from "@hotwired/stimulus"

// Submits the parent form whenever a watched element fires `change`.
// Wire with `data-action="change->auto-submit#submit"` on inputs whose
// changes should immediately PATCH the form.
export default class extends Controller {
  submit(event) {
    const form = event.target.form || this.element.closest("form")
    if (!form) return
    if (typeof form.requestSubmit === "function") {
      form.requestSubmit()
    } else {
      form.submit()
    }
  }
}
